const PAGE_TITLE = "Payment";

export { PAGE_TITLE };
